import { IComponentController, IScope } from 'angular';
import { IMenu, IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IProfil } from '../../../../../core/resources/profil.resource';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from "../../../../../core/services/menu/menu-item-forage.service";
import { ICriteresSuggeresOptions } from '../../../../../core/components/ex-criteres-suggeres/ex-criteres-suggeres.controller';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';

interface IPageMC0072 extends IComponentController {
    menuBandeau: IMenu;
    valeursEcran: any;
    dataValidationAffichage: any;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireCie: IFormulaire;
    docMultiOccurrenceOptions: IMultiOccurrenceOptions;
    docMultiOccurrence: IMultiOccurrence;
    optionsCriteresSuggeres: ICriteresSuggeresOptions;
}

/* @ngInject */
export default function Mc0072Controller(
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    mc2015Route: IRoute,
    mc2050Route: IRoute,
    mc2051Route: IRoute,
    MenuItemForage: IMenuItemForageClass,
    MenuItemEcran: IMenuItemEcranClass,
    FormulaireItem: IFormulaireItemClass,
    notificationHandler: INotificationHandler,
    Menu: IMenuClass,
    profil: IProfil,
    $scope: IScope,
    MenuItemAction: IMenuItemActionClass
) {
    const vm: IPageMC0072 = this;
    vm.valeursEcran = ecranDetails.params;
    vm.sel_tou = 0;
    vm.pecan = vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann;
     vm.menuItemInscriptions = new MenuItemAction(
                        'LBL_FLGSEL',
                        'BOUFLGSELTT',
                        (rowData: any) => ({ 
                            sel :  vm.sel_tou===0?1:0 ,
                            pecann: Number(vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann)
                        }),
                        {
                            icon: (rowData: any) => !vm.sel_tou?'check_box_outline_blank': 'check_box',
                            iconColor: (rowData: any) => !vm.sel_tou ? '' : 'rgb(0, 172, 193)',
                            disabled: () => (!vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann),
                            successAction: (response) => { 
                                 vm.sel_tou =  response.sel
                                  vm.pecan = response.pecann
                                vm.docMultiOccurrence.fetchDataList();
                            }
                        }
                    );
    vm.monoOccurrenceOptions = {
        noId: true,
        id: profil.preferences.ciecleint,
        fonctions: {
            suiviModification: false,
            exportation: false,
            afficherMenusDansEntete: true,
        },
     menus: [
            new MenuItemAction(
                'LBL_BTN',
                'BOUEXE',
                () => ({ 
                     pecann: vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann
                }),
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    disabled: () => (!vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann),
                    fonction: 'BOUEXE',
                    successAction: () => {
                      vm.docMultiOccurrence.fetchDataList();
                    }
                }),
            new MenuItemEcran(
                'LBL_BTN_MESSAGE',
                mc2051Route.NAME,
                () => ({
                    pecann: vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann
                }),
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    disabled: () => (!vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann)
                }
            )
        ]
    };
    vm.optionsCriteresSuggeres = {
        showFiltresInline: true,
        showAnnuler: false,
        iconFab: false
    };

    const docAff = new MenuItemForage(
        'LBL_BTN_DOC',
        (rowData: any) => `secure.${rowData.ecrcodoc}.ecran`,
        (rowData: any) => getParamItem(rowData),
        {
            icon: 'exit_to_app',
            disabled: (rowData: any) => !(rowData.ecrcodoc)
        }
    );

    vm.docMultiOccurrenceOptions = {
        bloc:'doc',
     //   actions: ,
        actionsMoreLigne: new Menu([
            new MenuItemEcran('LBL_IMPUTATION',
                mc2050Route.NAME,
                (rowData: any) => ({
                    doccleintref: rowData.dccleint
                }),
                {
                    icon: 'view_list',
                    iconButton: false
                }
            ),
            new MenuItemEcran('LBL_BTN_BOUTRB',
                mc2015Route.NAME,
                (rowData: any) => ({
                    dccleint: rowData.dccleint
                }),
                {
                    icon: 'launch',
                    iconButton: false
                }
            )
        ]),
        colonnesCachees: [
            'ecrcodoc',
            'ecrcledoc',
            'dccleint',
            'flgtrf',
            'flgferaut',
            'flgcou', 
            'cfaflgsel',
            'color',
        ],
        fonctions: {
            // customCriteresSuggeres: true,
           reinitialiserOuvrirCriteres: true,
           criteresSuggeresVisibles: localStorage.getItem('forageFromMenu') === 'oui' ,
           reinitialiser:true
        },
        criteresSuggeres: new Formulaire(
            'LBL_RECHERCHE',
            [
                new FormulaireItem('pecann', { required: true }),
                new FormulaireItem('t_flgtrf'),
                new FormulaireItem('t_flgferaut'),
                new FormulaireItem('tydcleint', { required: false }),
                new FormulaireItem('flgnoncpl'),
                new FormulaireItem('flgco'),
                new FormulaireItem('cifcleint'),
                new FormulaireItem('flgeng')
            ],
            {
                largeurDefaut: 33.33
            }
        ),
        //  actionsSelection: flgacc,
        colonnesVisibles: [ 
            { nom: 'docaffnumdoc01', largeur: 170, menu: [docAff] ,changeColor: true  },
            { nom: 'tydcod', largeur: 68 ,changeColor: true},
            { nom: 'entite_externe', largeur: 160 ,changeColor: true},
            { nom: 'mnt_original', largeur: 156 ,changeColor: true},
            { nom: 'trbsld', largeur: 139 ,changeColor: true},
            {
                nom: 'flgtrf_upd', largeur: 100, menu: [
                    new MenuItemAction(
                        'LBL_TRSFERT',
                        'BOUTRSFRT',
                        (rowData: any) => ({
                            flgtrf: rowData.flgtrf,
                            dccleint: rowData.dccleint
                        }),
                        {
                            icon: (rowData: any) => !rowData.flgtrf ? 'check_box_outline_blank' : 'check_box',
                            fonction: 'BOUTRSFRT',
                            iconColor: (rowData: any) => !rowData.flgtrf ? '' : 'rgb(0, 172, 193)',
                            successAction: () => { 
                              vm.docMultiOccurrence.fetchDataList();  
                            }
                        }
                    )
                ]
            },
            {
                nom: 'flgferaut_upd', largeur: 100, menu: [
                    new MenuItemAction(
                        'LBL_AUTR',
                        'BOUAUTR',
                        (rowData: any) => ({
                            flgferaut: rowData.flgferaut,
                            dccleint: rowData.dccleint,
							pecann: vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann    ,
						    cifcleint :  vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.cifcleint 
                        }),
                        {
                            icon: (rowData: any) => !rowData.flgferaut ? 'check_box_outline_blank' : 'check_box',
                            fonction: 'BOUAUTR',
                            iconColor: (rowData: any) => !rowData.flgferaut ? '' : 'rgb(0, 172, 193)',
                            successAction: () => {
                                vm.docMultiOccurrence.fetchDataList();
                            }
                        }
                    )
                ]
            },
            { nom: 'flgnoncpl', largeur: 100 },
            { nom: 'reception', largeur: 110 ,changeColor: true},
            { nom: 'nb_reception', largeur: 110 ,changeColor: true},
            { nom: 'tech_reception', largeur: 140 ,changeColor: true},
            { nom: 'docaffdat01', largeur: 110 ,changeColor: true},
            { nom: 'peccod', largeur: 90 ,changeColor: true},
            { nom: 'etdcod', largeur: 100 ,changeColor: true},
            { nom: 'etddsc', largeur: 150 ,changeColor: true},
            { nom: 'docaffdsc01', largeur: 320,changeColor: true },
            { nom: 'date_debut_contrat', largeur: 150 },
            { nom: 'date_fin_contrat', largeur: 130 },
            { nom: 'mnt_recep_non_fact', largeur: 175 },
            { nom: 'mnt_tot', largeur: 126 },
            { nom: 'en_cour', largeur: 90 }
        ],
        colonnesFixesDroite: [
            {
                nom: 'flgcou_upd', largeur: 100, menu: [
                    new MenuItemAction(
                        'LBL_FLGCOU',
                        'BOUFLGCOU',
                        (rowData: any) => ({
                            flgcou: rowData.flgcou,
                            dccleint: rowData.dccleint
                        }),
                        {
                            icon: (rowData: any) => !rowData.flgcou ? 'check_box_outline_blank' : 'check_box',
                            fonction: 'BOUFLGCOU',
                            iconColor: (rowData: any) => !rowData.flgcou ? '' : 'rgb(0, 172, 193)',
                            successAction: () => { 
                                vm.docMultiOccurrence.fetchDataList();  
                            }
                        }
                    )
                ]
            },
            { nom: 'sel', largeur: 110 , menu: [
                    new MenuItemAction(
                        'LBL_FLGSEL',
                        'BOUFLGSEL',
                        (rowData: any) => ({
                            flgcou: rowData.flgcou,
                            dccleint: rowData.dccleint,
                            flgnoncpl:rowData.flgnoncpl
                        }),
                        {
                            icon: (rowData: any) => !rowData.cfaflgsel?'check_box_outline_blank': 'check_box',
                            iconColor: (rowData: any) => !rowData.cfaflgsel ? '' : 'rgb(0, 172, 193)',
                            successAction: () => {
                                vm.docMultiOccurrence.fetchDataList();
                            },
                            errorAction(response) { 
                               notificationHandler.erreur({
                               lblMessage: response.data.message
                        });       
                            },
                        }
                    )
                ]}
        ]

    };
        $scope.$watch('::vm.docMultiOccurrence', () => {
        if (vm.docMultiOccurrence) {
            vm.docMultiOccurrence.once('dataListUpdate', () => { 
                //On ne veut pas fermer le dialog après le premier fetchDataList. 
                vm.docMultiOccurrence.on('dataListUpdate', () => {
                 if ( vm.docMultiOccurrence?.etatSelected?.criteresSuggeresData?.pecann != vm.pecan)  {
                      vm.sel_tou = 0;
                 }
                    
                });
            })
        }
    });
        function getParamItem(rowData: any) {  
        if (rowData.ecrcodoc === 'ac0010') {
            return { id: rowData.dccleint  };
        } else  {
            return { id: rowData.ecrcledoc };
        } 
    };
}
